import { render, staticRenderFns } from "./ConfirmForm.vue?vue&type=template&id=50750c0c"
import script from "./ConfirmForm.vue?vue&type=script&lang=js"
export * from "./ConfirmForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports